export function Alert(str) {
    alert(str);
}